const ENTER = 'Enter'

export const onKeyDown: React.KeyboardEventHandler<HTMLInputElement> = e => {
  if (e.key === ENTER) {
    const inputElement = e.target as HTMLInputElement
    inputElement.blur()
  }
}
